module.exports = __webpack_public_path__ + "img/p37.bbda7728.gif";